<template>
  <main>
    <menus/>
    <section class="content">
      <header class="search">
        <figure class="select">
          <!-- 订单状态 -->
          <el-select 
            v-model="search.order_client_status" 
            clearable placeholder="订单状态" 
            @change="changeSearch">
            <el-option
              v-for="item in options.clientStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!-- 签证类别 -->
          <el-select 
            v-model="search.visaKind" clearable 
            placeholder="签证类别" 
            @change="changeSearch">
            <el-option
              v-for="item in options.visaKind"
              :key="item.VisaKindID"
              :label="item.Name"
              :value="item.Name">
            </el-option>
          </el-select>
          <!-- 签证形式 -->
          <el-select 
            v-model="search.visaForm" clearable 
            placeholder="签证形式" 
            @change="changeSearch">
            <el-option
              v-for="item in options.visaForm"
              :key="item.VisaFormID"
              :label="item.Name"
              :value="item.Name">
            </el-option>
          </el-select>
          <!-- 日期选择 -->
          <el-date-picker
            v-model="search.date"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="changeSearch">
          </el-date-picker>
        </figure>
        <div class="input">
          <el-input v-model="search.keyword" maxlength="30" @change="changeSearch" placeholder="请输入搜索内容">
            <el-select v-model="search.keyword_type" slot="prepend" placeholder="请选择">
              <el-option label="订单号" value="OrderNO"></el-option>
              <el-option label="产品名称" value="ProductName"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="changeSearch"></el-button>
          </el-input>
        </div>
      </header>
      <el-table :data="list" v-loading="loading">
        <el-table-column align="center" width="120" prop="OrderNO" label="订单号"></el-table-column>
        <el-table-column align="center" prop="ProductName" label="产品名称"></el-table-column>
        <el-table-column align="center" width="100" label="金额">
          <template slot-scope="s">
            <span class="bold">{{ s.row.total_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="150" label="状态">
          <template slot-scope="s">
            {{ s.row.isPaid | getPaidDesc }}
          </template>
        </el-table-column>
        <el-table-column align="left" width="160" label="操作">
          <template slot-scope="s">
            <nav>
              <router-link :to="{ name: 'order_detail', query: { OrderNO: s.row.OrderNO } }">详情</router-link>
              <router-link :to="{ name: 'order_pay', query: { orderNo: s.row.OrderNO } }" class="pay" v-show="s.row.isPaid !== 1">支付</router-link>
              <!-- <a class="up" v-show="s.row.isPaid === 1">上传资料</a> -->
              <!-- <a class="cancel" v-show="s.row.isPaid === 1">取消</a> -->
            </nav>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size.sync="search.page_size"
        :current-page.sync="search.page"
        :total="search.total"
        :hide-on-single-page="true"
        @current-change="changePage">
      </el-pagination>
    </section>
    
  </main>
</template>

<script>
import menus from '@components/menu';
import $visa from '@api/visa';
export default {
  components: {
    menus
  },
  data () {
    return {
      loading: true,
      options: {},
      search: {
        order_client_status: null, // 订单状态
        visaKind: null,
        visaForm: null,
        date: [],
        keyword_type: 'OrderNO', // 关键词类型
        keyword: null,
        page: 1,
        page_size: 10,
        total: 0
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      list: []
    }
  },
  created () {
    this.getVisaOptions().then(options => {
      this.options = options;
    });
    this.getList();
  },
  filters: {
    getPaidDesc (type) {
      const desc = ['待付款', '已付款', '部分付款'];
      return desc[type] || type || null;
    }
  },
  methods: {
    // 跳转详情
    goDetail (id) {
      
    },
    // 切换页码
    changePage (page) {
      this.changeSearch('page', page);
      window.scrollTo({ 
        top: 0, 
        behavior: "smooth" 
      });
    },
    // 更新搜索条件
    changeSearch (attr, value) {
      let data = {};
      attr && (data[attr] = value);
      if ( attr && attr !== 'page' ) { data.page = 1; }
      this.search = { ...this.search, ...data };
      this.getList();
    },
    // 获取订单列表
    getList () {
      const { order_client_status, visaKind, visaForm, date = [], keyword_type, keyword, page, page_size } = this.search;
      let data = {
        order_client_status,
        visaKind, visaForm, keyword_type, keyword,
        page, page_size
      }
      if ( date && date.length === 2 ) {
        const [ start_time, end_time ] = date;
        data = { ...data, start_time, end_time };
      }
      this.loading = true;
      $visa.list(data).then(res => {
        const { data, total } = res;
        this.list = data;
        this.search = { ...this.search, total };
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped src="./list.css"></style>